import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { BrowserRouter } from 'react-router-dom';
import App from '@components/App/App';

import './i18n';

const catalog = document.getElementById('catalog_2023') as HTMLElement;

if (catalog) {
    ReactDOM.createRoot(catalog).render(
        <BrowserRouter>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
                <App />
            </QueryParamProvider>
        </BrowserRouter>
    );
}
